//
// ┌─────────────────────┐
// │ DO NOT EDIT BY HAND │
// └─────────────────────┘
//
// Generated by build.mjs in zinnia-icons
//
import { mapPropsToSvgProps, Props } from "../utils";
function IconStatusAppApproval(iconProps: Props) {
  const props = mapPropsToSvgProps(iconProps);
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M14 0H12V3H14V0ZM20.19 3L18.66 1.7L16.73 4L18.27 5.28L20.19 3ZM9.27 4L7.34 1.7L5.81 3L7.73 5.3L9.27 4ZM19 10H15V7C15 6.46957 14.7893 5.96086 14.4142 5.58579C14.0391 5.21071 13.5304 5 13 5H11.57L6 11.64V19H8V12.36L12.5 7H13V12H19C19.2652 12 19.5196 12.1054 19.7071 12.2929C19.8946 12.4804 20 12.7348 20 13V15.68L15.53 21H6V23H16.47L22 16.4V13C22 12.2044 21.6839 11.4413 21.1213 10.8787C20.5587 10.3161 19.7956 10 19 10ZM2 23H4V12H2V23Z" fill="currentColor" /></svg>;
}
export default IconStatusAppApproval;